import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';

import List from './list';
import View from './view';

/**
 *   Create index file for Incoming_webhook
 */

export default function JourneyIndex() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = List;
      break;

    case 'view':
      ActualPage = View;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

